<app-generic-input slug='activity_kind'>
    <app-filters-placeholder-dropdown class='placeholder'>
        <span>{{ data.filters.activity_kinds || "סוג פעילות" }}</span>
        <span *ngIf='!data.filters.activity_kinds' class='small'>(עיקרי ומשני)</span>
        <span *ngIf='data.filters.activity_kinds' class='clear' (click)='data.filters.activity_kinds = null; $event.stopPropagation()'>&times;</span>
    </app-filters-placeholder-dropdown>
    <app-filters-dropdown-list-selector slug='activity_kind' class='popup' [data]='options' (selected)='data.filters.activity_kinds = $event'>
    </app-filters-dropdown-list-selector>
</app-generic-input>